import Vue from "vue";
import VueRouter from "vue-router";
// import {checkState} from '../views/API/login.js'
import { Message } from "element-ui";
import { setToken, hasToken } from "../assets/js/storage";
import { checkState } from "../views/API/login";
import { menuRouter } from "./menu-router.js";

Vue.use(VueRouter);
//路由导航冗余报错（路由重复）
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
const routes = [
  {
    path: "/",
    redirect: "Layout",
  },
  {
    path: "/Layout",
    name: "Layout",
    component: () => import("../views/Layout/index.vue"),
    meta: {
      title: "首页",
    },
    redirect: "Home",
    children: [...menuRouter],
  },
];

const router = new VueRouter({
  routes,
});
// 路由前置守卫
router.beforeEach(async (to, from, next) => {
  if (hasToken()) {
    return next();
  } else {
    if (to.meta.islogin) {
      Message({
        message: "未查询到登录信息或token过期,请先登录",
        type: "error",
      });
      return next({ path: "/Home", query: { t: Date.now() } });
    }
  }
  next();
});

export default router;
